import { useEffect } from "react";
import { useHistory } from "react-router";
// Components

// Images
import assetLibrary from '../../assets/img/partnerPortal/marketing/asset_library.svg';
import social from '../../assets/img/partnerPortal/marketing/social.svg';
import campaigns from '../../assets/img/partnerPortal/marketing/campaigns.svg';
import events from '../../assets/img/partnerPortal/marketing/events.svg';
import wave from '../../assets/img/partnerPortal/EnablementSales/full wave.png';

// Scss
import '../../assets/css/partnerProgram.scss';
import '../../assets/css/partnerPortal/welcome.scss';



import Title from "../../components/Title";
import CardRole from "../../components/CardRole";
import BannerOne from "../../components/BannerOne";

function Marketing() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  const TITLE = "Marketing Center";

  return (
    <>
        <div className="mb-3">
            <BannerOne bannerImage={wave} title={TITLE} hasNoButton={true} />
            <div className="containerAll">
                <div className="flexToBlockCard align-items-start w-100 margin96Botton">
                    <CardRole icon={assetLibrary} title="Asset library" subTitle={"Co-brand and customize your digital content for syndication, social, email & more."} buttonLink={"https://partners.dynatrace.com/#/collateral/browse"} addMargin={"margin32 moreButtonMargin"}  />
                    <CardRole icon={social} target="_blank" title="How to launch a campaign" subTitle={"Concise video tutorials to assist you with setting up and implementing campaigns in the Dynatrace partner portal."} buttonLink={"https://partners.dynatrace.com/#/collateral/programs/8a9983d989d674ac0189d9db7e511df6"} addMargin={"margin32-2"}  />
                    <CardRole icon={campaigns} title="Launch campaigns" subTitle={"Activate ready-to-use campaigns to create awareness and generate leads."} buttonLink={"https://partners.dynatrace.com/#/campaigns/browse"} addMargin={"margin32"}  />
                    <CardRole icon={events} title="Marketing support" subTitle={"Contact us to talk content and tactics to help drive customer demand, new leads and  pipeline."} buttonLink={"mailto:partnermarketing@dynatrace.com"} addMargin={"margin32"} />
                </div>
            </div>
        </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default Marketing;

